<div
  class="hts-code-card"
  [class.hts-code-card--compact]="isCompact"
  [class.hts-code-card--hover]="isShowHoverBackground"
  [class.hts-code-card--withdrawn]="data.isWithdrawn"
  [class.hts-code-card--stale]="isStale"
  [class.hts-code-card--dimmed]="isDimmed"
  [class.hts-code-card--busy]="isInserting"
  [class.hts-code-card--no-body]="!isShowBody"
>
  <div class="hts-code-card__header">
    <div class="hts-code-card__code">
      <app-bina-code-item
        *ngFor="let group of codeGroups; trackBy: trackByIndex"
        [groupNumber]="group.value"
        [showDot]="group.showDot"
        [capsulePlaceholderCount]="2"
      ></app-bina-code-item>
    </div>

    <div class="hts-code-card__main">
      <div class="hts-code-card__title" *ngIf="isShowTitle" [attr.title]="data.title">
        <span class="hts-code-card__title-text">{{ data.title }}</span>
      </div>
      <span
        class="hts-code-card__tag hts-code-card__tag--withdrawn"
        *ngIf="data.isWithdrawn"
        nz-tooltip
        nzTooltipPlacement="top"
        [nzTooltipTitle]="'BINA_CATALOG.WITHDRAWN_TOOLTIP' | translate"
      >
        {{ "BINA_CATALOG.WITHDRAWN" | translate }}
      </span>
      <span
        class="hts-code-card__tag hts-code-card__tag--assistant"
        *ngIf="isAssistantTagVisible"
        nz-tooltip
        nzTooltipPlacement="top"
        [nzTooltipTitle]="'BINA_CATALOG.SAVED_VIA_ASSISTANT_TOOLTIP' | translate"
      >
        {{ "BINA_CATALOG.SAVED_VIA_ASSISTANT" | translate }}
      </span>
    </div>

    <div class="hts-code-card__actions">
      <span class="hts-code-card__current" *ngIf="isCurrent">
        <i class="fa fa-check" aria-hidden="true"></i>
        {{ "BINA_CATALOG.SUGGESTION_CURRENT" | translate }}
      </span>
      <button
        *ngIf="isShowInsertButton"
        type="button"
        class="hts-code-card__insert"
        nz-tooltip
        nzTooltipPlacement="top"
        [nzTooltipTitle]="'INSERT_TO_LINE_ITEM' | translate"
        [attr.aria-label]="'INSERT_TO_LINE_ITEM' | translate"
        [disabled]="isInserting"
        (click)="onInsert()"
      >
        <img *ngIf="!isInserting" src="assets/icons/icon_insert_item.svg" alt="" />
        <i *ngIf="isInserting" class="fa fa-spinner fa-spin" aria-hidden="true"></i>
      </button>
      <ng-content select="[card-actions]"></ng-content>
    </div>
  </div>

  <div class="hts-code-card__body" *ngIf="isShowBody">
    <p class="hts-code-card__description" *ngIf="isShowDescription" #description>
      {{ displayedDescription }}
      <span
        *ngIf="isShowMore"
        class="hts-code-card__more"
        role="button"
        tabindex="0"
        [attr.aria-expanded]="isExpanded"
        (click)="toggleShowMore()"
        (keydown.enter)="toggleShowMore()"
      >
        {{ (isExpanded ? "BUTTON.SHOW_LESS" : "BUTTON.SHOW_MORE") | translate }}
      </span>
    </p>
    <div class="hts-code-card__meta" *ngIf="isShowMatched">
      {{ "BINA_CATALOG.SUGGESTION_MATCHED" | translate : { text: data.matchedText } }}
    </div>
    <div class="hts-code-card__meta" *ngIf="isShowCatalogSource">{{ "BINA_CATALOG.SUGGESTION_SOURCE_CATALOG" | translate }}</div>
    <div class="hts-code-card__meta" *ngIf="isShowSource">{{ data.sourceKey | translate }}</div>
  </div>

  <ng-content select="[card-footer]"></ng-content>
</div>
